// Orders and Returns are not here: OrdersTable and ReturnsTable own their
// own columns because they list grouped records, not single rows.
const getHeadings = (sectionType) => {
  let main_head;
  let custom_head;
  switch (sectionType) {
    case 'inventory':
      main_head = ['nameOfMedicine', 'potencyOrPower', 'quantity', 'mrp', 'discount', 'gst'];
      custom_head = ['name', 'power', 'quantity', 'mrp', 'discount', 'GST %'];
      break;

    case 'Distributors':
      main_head = ['companyName', 'address', 'ownerName', 'phone', 'email'];
      custom_head = ['Company Name', 'address', 'owner', 'phone', 'email'];
      break;

    case 'medicines':
      main_head = ['nameOfMedicine', 'company', 'potencyOrPower', 'quantity', 'minQuantity', 'typeOfMedicine'];
      custom_head = ['Medicine Name', 'Company', 'Power', 'Current Qty', 'Min Qty', 'Type'];
      break;
  }

  return { main: main_head, display: custom_head };
};

export { getHeadings };
